// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zyvn","top":"styles_top__dW18j","left":"styles_left__LB0Sc","description":"styles_description__2j9EY"};